import React from 'react';
import { Box, Modal, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DIALOG_BOX_STYLE } from '../../_constants/styleConst';
import { I18nMessage } from '../../types/type';
import { useNavigate } from 'react-router-dom';
import { setSessionStorageRedirectUrl } from '../../_utils/utils';
import { INSPEX_PATHNAME } from '../../_constants/Const';

interface ErrorModalProps {
  message: string | I18nMessage;
  onClose: () => void;
}

const ErrorModal: React.FC<ErrorModalProps> = ({ message, onClose }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const formatMessage = (): string => {
    if (typeof message === 'string') {
      return t(message);
    }
    return t(message.messageKey, message.values);
  };

  const closeErrorModal = () => {
    onClose();
    if (message === 'ERR_SESSION') {
      setSessionStorageRedirectUrl();
      navigate(INSPEX_PATHNAME.LOGIN);
    }
    if (typeof message !== 'string') {
      if (message.messageKey === 'ERR_INVALID_TYPE') {
        navigate(INSPEX_PATHNAME.RMA_SEARCH);
      }
    }
  };

  return (
    <Modal
      open={true}
      onClose={closeErrorModal}
      aria-labelledby="error-modal-title"
      aria-describedby="error-modal-description"
    >
      <Box
        sx={{
          ...DIALOG_BOX_STYLE,
          minHeight: '200px',
          maxHeight: '400px',
        }}
      >
        <Typography id="error-modal-title" variant="h6" component="h2">
          {t('LBL_ERROR_MODAL_TITLE')}
        </Typography>
        <Typography
          id="error-modal-description"
          color="error"
          sx={{
            mt: 2,
            maxHeight: '250px',
            minHeight: '46px',
            overflowY: 'auto',
            wordBreak: 'break-word',
          }}
        >
          {formatMessage()}
        </Typography>
        <Box sx={{ height: '42px' }}>
          <Button
            onClick={closeErrorModal}
            color="primary"
            variant="contained"
            sx={{ position: 'absolute', right: '5%', bottom: '5%' }}
          >
            {t('BTN_OK')}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ErrorModal;
